import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { HeaderBarComponent } from '@nimmsta/ng-commons-lib/header-bar';
import { SoftwareType } from '@nimmsta/ng-commons-lib/models';
import { HttpParams } from '@angular/common/http';
import { SoftwareTypeService } from '../services/software/software-type.service';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { map } from 'rxjs';

@Component({
  selector: 'app-software-overview',
  templateUrl: './software-overview.component.html',
  styleUrls: ['./software-overview.component.scss'],
  imports: [HeaderBarComponent, TranslatePipe, RouterLink],
})
export class SoftwareOverviewComponent {
  private softwareTypeService = inject(SoftwareTypeService);

  types = toSignal(
    this.softwareTypeService
      .list({
        additionalQueryParams: new HttpParams().append('unpaged', true),
        sortColumn: 'name',
        sortOrder: 'asc',
      })
      .pipe(map((types) => types.content)),
    { initialValue: [] as SoftwareType[] },
  );
}
